export const defaultOptions = {
  indexAxis: 'y' as const,
  interaction: {
    mode: 'index' as const,
    intersect: false,
  },
  maintainAspectRatio: false,
  responsive: true,
  parsing: {
    yAxisKey: 'x',
  },
  scales: {
    y: {
      display: false,
      stacked: true,
      grid: {
        display: false,
      },
    },
    x: {
      display: false,
      stacked: true,
      max: 100,
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
    title: {
      display: false,
    },
  },
};
